import React from "react";
import Title from "../Title";
// import Cartcolumns from "./CartColumns";
import CartList from "./CartList";
import CartTotals from "./CartTotals";
import CartDeliveryChoice from "./CartDeliveryChoice";

export default function Cart() {
  return (
    <section className="py-5">
      <div className="container">
        <Title title="Dine Bestillinger" center />
      </div>

      <CartList />
      {/* <CartDeliveryChoice/> */}
      <CartTotals />
    </section>
  );
}
